import { useState } from 'react';

export default function FinalCTA() {
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitStatus('idle');

    try {
      const form = e.target as HTMLFormElement;
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form)
      });

      if (response.ok) {
        setSubmitStatus('success');
        form.reset();
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    }
  };

  return (
    <section id="trial-form" className="relative py-16 md:py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/54082572c0c7158695af688e9c94ab2d.jpg"
          alt="Professional workspace"
          className="w-full h-full object-cover object-center animate-[zoomIn_20s_ease-in-out_infinite_alternate]"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/65 to-black/75"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="text-white animate-[fadeInLeft_1s_ease-out]">
            <div className="inline-block bg-white/20 backdrop-blur-sm px-5 py-2.5 rounded-full mb-6 border border-white/30 shadow-lg">
              <span className="text-sm font-medium">🚀 Liity menestyjiiin</span>
            </div>
            
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight font-inter">
              Aloita kasvattamaan arvostelujasi tänään
            </h2>
            <p className="text-lg md:text-xl text-white/95 leading-relaxed mb-10">
              Liity muiden suomalaisten yritysten joukkoon, jotka ovat parantaneet näkyvyyttään ja kasvattaneet myyntiään Boostion avulla. Ilmainen 14 päivän kokeilu.
            </p>
          </div>

          <div className="bg-white rounded-2xl md:rounded-[2rem] shadow-2xl p-6 md:p-10 animate-[fadeInRight_1s_ease-out] hover:shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)] transition-all duration-500 border border-gray-100">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
              Aloita ilmainen kokeilu
            </h3>
            <p className="text-gray-600 mb-6 md:mb-8 text-sm md:text-base">
              Täytä tiedot ja aloita 14 päivän ilmainen kokeilu heti
            </p>

            <form 
              action="https://usebasin.com/f/0d049f5c3c5a" 
              method="POST" 
              encType="multipart/form-data" 
              id="trial-signup-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="space-y-5 md:space-y-6"
            >
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                  Nimi <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  className="w-full px-4 py-3.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all text-base"
                  placeholder="Matti Meikäläinen"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                  Sähköposti <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full px-4 py-3.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all text-base"
                  placeholder="matti@yritys.fi"
                />
              </div>

              <div>
                <label htmlFor="company" className="block text-sm font-semibold text-gray-700 mb-2">
                  Yritys <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  required
                  className="w-full px-4 py-3.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all text-base"
                  placeholder="Yritys Oy"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
                  Puhelinnumero <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  className="w-full px-4 py-3.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all text-base"
                  placeholder="+358 40 123 4567"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold py-4 px-8 rounded-xl hover:from-blue-600 hover:to-blue-700 transform hover:scale-[1.02] transition-all duration-300 shadow-lg hover:shadow-xl text-base whitespace-nowrap"
              >
                Aloita ilmainen kokeilu
              </button>

              {submitStatus === 'success' && (
                <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-xl text-green-800 text-sm">
                  ✅ Kiitos! Olemme yhteydessä mahdollisimman pian!
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-xl text-red-800 text-sm">
                  ❌ Jokin meni pieleen. Yritä uudelleen.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes zoomIn {
          from {
            transform: scale(1);
          }
          to {
            transform: scale(1.05);
          }
        }
      `}</style>
    </section>
  );
}